var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"cancel__btn btn mb-2",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" Cancel ")])
}
var staticRenderFns = []

export { render, staticRenderFns }